import BloomLogo from '../../assets/bloom-logo.svg?react'
import GoBackLink from '../components/layout/GoBackLink'
import AccountVerificationForm from '../containers/users/AccountVerificationForm'

const VerifyEmail = () => {
  return (
    <div className='min-h-screen flex flex-col items-center justify-center bg-gray-50'>
      <div className='max-w-md flex items-start mb-2 w-full'><GoBackLink responsive={false} /></div>
      <div className='max-w-md w-full space-y-8 p-8 bg-white rounded-lg shadow'>
        <div className='flex justify-center items-center mb-12 flex-col gap-8'>
          <BloomLogo className='logo h-12 w-auto' />
        </div>
        <AccountVerificationForm />
      </div>
    </div>
  )
}

export default VerifyEmail
